export enum Country {
  USA = 'usa',
  SWITZERLAND = 'switzerland',
  FRANCE = 'france',
  ENGLAND = 'england',
  ITALY = 'italy',
  GERMANY = 'germany',
  AUSTRIA = 'austria',
  BELGIUM = 'belgium',
  SPAIN = 'spain',
  IRELAND = 'ireland',
}
